var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIllus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 164,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .074h93.93v118.794H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .074h93.93v118.794H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.015.002H99.47V44.1H.015z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB354E",
    d: "M48.744 18.339a2.03 2.03 0 0 0-2.513-1.386L4.677 29.043a2.033 2.033 0 0 0-1.382 2.52l1.103 3.809 7.341 25.342a2.03 2.03 0 0 0 2.513 1.386l41.554-12.09a2.033 2.033 0 0 0 1.382-2.519l-7.34-25.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C87F",
    d: "M64.928 45.677c0 6.773-5.48 12.264-12.237 12.264-6.759 0-12.238-5.49-12.238-12.264s5.48-12.264 12.238-12.264 12.237 5.49 12.237 12.264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BE00",
    d: "M22.534 29.471 10.837 49.776c-.736 1.277.183 2.873 1.654 2.873h23.395c1.47 0 2.39-1.596 1.654-2.873L25.843 29.471c-.735-1.276-2.574-1.276-3.31 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CCEF7",
    d: "M66.924 25.737a2.245 2.245 0 0 1-1.342-2.459l1.772-10.027a2.23 2.23 0 0 0-1.342-2.46L51.987 4.94a2.226 2.226 0 0 0-2.69.779l-5.847 8.327a2.24 2.24 0 0 1-3.118.542 2.25 2.25 0 0 1-.54-3.124l5.849-8.327A6.666 6.666 0 0 1 53.705.802l14.026 5.85a6.69 6.69 0 0 1 4.028 7.38l-1.77 10.027a2.24 2.24 0 0 1-3.065 1.678"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAE2F7",
    d: "M97.145 37.512a6.72 6.72 0 0 0-4.116-5.743L18.096.516a6.7 6.7 0 0 0-6.966 1.121L6.7 5.475l90.85 37.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CCEF7",
    d: "M42.873 10.85 18.096.516a6.7 6.7 0 0 0-6.965 1.121L6.7 5.475l24.777 10.334 4.43-3.838a6.7 6.7 0 0 1 6.965-1.12"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.182 44.842)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBF5FD",
    d: "M0 .074 6.47 114.64a4.477 4.477 0 0 0 4.466 4.229h72.057a4.477 4.477 0 0 0 4.466-4.23L93.929.075z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.182 44.842)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AAE2F7",
    d: "M93.93.074H0L6.47 114.64a4.477 4.477 0 0 0 4.466 4.229h67.338a2.24 2.24 0 0 0 2.237-2.242 2.24 2.24 0 0 0-2.237-2.24H31.405c-3.649 0-6.629-2.924-6.708-6.58l-2.025-94.138c-.081-3.77 2.946-6.87 6.708-6.87h64.17z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7CCEF7",
    d: "M17.71 155.305a2.8 2.8 0 0 1-2.79-2.68l-4.113-94.138a2.8 2.8 0 0 1 2.671-2.922c1.55-.03 2.848 1.132 2.916 2.677l4.112 94.138a2.8 2.8 0 0 1-2.67 2.922q-.063.004-.125.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAE2F7",
    d: "M76.583 155.305q-.063 0-.125-.003a2.8 2.8 0 0 1-2.67-2.922L77.9 58.242c.067-1.545 1.415-2.71 2.915-2.677a2.8 2.8 0 0 1 2.671 2.922l-4.112 94.138a2.8 2.8 0 0 1-2.791 2.68M47.147 155.305a2.8 2.8 0 0 1-2.796-2.802V58.365a2.8 2.8 0 0 1 2.796-2.802 2.8 2.8 0 0 1 2.795 2.802v94.138a2.8 2.8 0 0 1-2.795 2.802"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.383 2.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBF5FD",
    d: "M96.373 43.927 1.393 4.314A2.242 2.242 0 0 1 3.113.174l94.98 39.614a2.242 2.242 0 0 1-1.72 4.14",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AAE2F7",
    d: "M31.49 155.305a2.8 2.8 0 0 1-2.794-2.737L26.46 58.43a2.8 2.8 0 0 1 2.73-2.867h.067a2.8 2.8 0 0 1 2.794 2.736l2.236 94.138a2.803 2.803 0 0 1-2.73 2.868zM62.848 155.305h-.068a2.8 2.8 0 0 1-2.73-2.868L62.242 58.3c.038-1.55 1.398-2.736 2.862-2.736a2.8 2.8 0 0 1 2.73 2.867l-2.193 94.138a2.8 2.8 0 0 1-2.793 2.737M29.413 14.948a2.233 2.233 0 0 1 2.924-1.209L5.495 2.544a2.241 2.241 0 0 0-1.718 4.139l26.842 11.195a2.24 2.24 0 0 1-1.206-2.93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIllus);
export default __webpack_public_path__ + "static/media/trash-illus.5cb7a9862135f5e69d4b9373190f4902.svg";
export { ForwardRef as ReactComponent };